import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bba0aeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-leads-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "summary-leads-content_controls" }
const _hoisted_4 = { class: "summary-leads-content_controls__label" }
const _hoisted_5 = { class: "summary-leads-content_controls__value" }

import { PropType, ref, computed } from 'vue'

const __default__ = { name: 'SummaryLeads' }

interface SummaryType {
  allClues: number
  effectiveClues: number
  fbuClues: number
  lbuClues: number
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: Object as PropType<SummaryType>,
    required: true
  }
},
  setup(__props) {

const props = __props

const summaryEnum = ref([
  { label: '全部线索', value: 0, class: 'all', key: 'allClues', icon: require('@/assets/index/new-clue.svg') },
  { label: '有效线索', value: 0, class: 'valid', key: 'validClues', icon: require('@/assets/index/new-business.svg') },
  { label: '未来线索', value: 0, class: 'future', key: 'futureClues', icon: require('@/assets/index/new-visitor.svg') },
  { label: '投放线索', value: 0, class: 'put', key: 'pushClues', icon: require('@/assets/index/new-follow.svg') },
  { label: '无效线索', value: 0, class: 'invalid', key: 'invalidClues', icon: require('@/assets/index/clue.svg') }
])

const summaryEnumComputed = computed(() => {
  return summaryEnum.value.map((item: any) => {
    item.value = props.value ? props.value[item.key] : 0
    return item
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryEnumComputed.value, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        class: _normalizeClass(["summary-leads-content", item.class]),
        key: item.key
      }, [
        _createElementVNode("img", {
          class: "summary-leads-content_icon",
          src: item.icon
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(item.label), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(item.value || 0), 1)
        ])
      ], 2))
    }), 128))
  ]))
}
}

})